export default {
  allWeek: 'Cały tydzień',
  allDay: 'Cały dzień',
  noDays: 'Nie wybrano żadnych dni',
};
